module.exports = __webpack_public_path__ + "static/winebox-persona-2d724d1dab0f1cf68468cdeff24ce050.png";